import { useRequiredContext } from "@redotech/react-util/context";
import { CurrentProductInfo } from "@redotech/redo-model/concierge-conversation/rpc/concierge-conversation-schema";
import {
  ExtensionShopifyClientContext,
  isOnProductPage,
} from "@redotech/redo-shopify-extension/shopify";
import {
  ExtensionShopifyClient,
  ShopifyProduct,
} from "@redotech/shopify-client/ajax";
import { useQuery } from "@tanstack/react-query";

// Private utility functions for product info handling
function getSelectedVariantId(
  productData: ShopifyProduct | null,
): number | string | undefined {
  const urlParams = new URLSearchParams(location.search);
  const variantFromUrl = urlParams.get("variant");

  if (variantFromUrl) {
    return parseInt(variantFromUrl);
  } else if (
    productData &&
    productData.variants &&
    productData.variants.length > 0
  ) {
    // @ts-expect-error TODO: noUncheckedIndexedAccess FIXME
    return productData.variants[0].id;
  }

  return undefined;
}

function getStorefrontProductUrl(): string | undefined {
  if (isOnProductPage()) {
    return `${location.origin}${location.pathname}`;
  }

  return undefined;
}

async function fetchProductInfo(
  extensionShopifyClient: ExtensionShopifyClient,
  productHandle: string,
): Promise<CurrentProductInfo> {
  const product: ShopifyProduct =
    await extensionShopifyClient.productGet(productHandle);
  return {
    productId: product.id.toString(),
    productName: product.title,
    variantId: getSelectedVariantId(product)?.toString(),
    storefrontProductUrl: getStorefrontProductUrl(),
  };
}

export function useCurrentProductInfo(productHandle: string | null) {
  const extensionShopifyClient = useRequiredContext(
    ExtensionShopifyClientContext,
  );
  return useQuery({
    queryKey: ["currentProductInfo", productHandle],
    queryFn: () => fetchProductInfo(extensionShopifyClient, productHandle!),
    enabled: !!productHandle,
    staleTime: 30 * 1000,
    gcTime: 5 * 60 * 1000,
    refetchOnWindowFocus: true,
    refetchOnMount: true,
  });
}

export { type CurrentProductInfo } from "@redotech/redo-model/concierge-conversation/rpc/concierge-conversation-schema";
